import { FilterInterface, FilterItemInterface, SiteFilterInterface, SiteFilterStateInterface } from '../models';
import { SiteFilterState } from '../models/site-filter-state.model';

import { SiteFilterActions, SiteFilterActionType } from './actions';

const initialState: SiteFilterStateInterface = new SiteFilterState({
  siteFilters: undefined,
  managementFilters: undefined,
});

export function siteFilterReducer(state: SiteFilterStateInterface = initialState,
                                  action: SiteFilterActions): SiteFilterStateInterface {

  switch(action.type) {

    // Clear the state if loading or loading failed
    case SiteFilterActionType.LoadSiteFilter:
    case SiteFilterActionType.LoadSiteFilterFailed:
      return {
        ...state,
        siteFilters: undefined,
      };

      // Whether update or load we update the state the same way
    case SiteFilterActionType.LoadSiteFilterCompleted:
    case SiteFilterActionType.UpdateSiteFilterCompleted:
      return  {
        ...state,
        siteFilters: action.payload as SiteFilterInterface,
      };

    case SiteFilterActionType.LoadManagmentSiteFilter:
    case SiteFilterActionType.LoadManagmentSiteFilterFailed:
      return {
        ...state,
        managementFilters: undefined,
      };

    case SiteFilterActionType.LoadManagmentSiteFilterCompleted:
      const filterData: FilterInterface[] = action.payload as FilterInterface[];

      return {
        ...state,
        managementFilters: filterData,
      };

    case SiteFilterActionType.UpdateManagmentSiteFilterCategoryCompleted:
      const updatedFilter: FilterInterface = action.payload as FilterInterface;

      const filtersCopy: FilterInterface[] = state.managementFilters.map((filter: FilterInterface) => {
        if(filter.id === updatedFilter.id) {
          return {
            ...filter,
            name: updatedFilter.name,
            enabled: updatedFilter.enabled,
          };
        }
        return filter;
      });

      return {
        ...state,
        managementFilters: filtersCopy,
      };

    case SiteFilterActionType.CreateManagementSiteFilterItemCompleted:
    case SiteFilterActionType.UpdateManagementSiteFilterItemCompleted:
      const payloadData: { filterId: number, filterItem: FilterItemInterface } = action.payload;

      const itemFiltersCopy: FilterInterface[] = state.managementFilters.map((filter: FilterInterface) => {
        if(filter.id === payloadData.filterId) {
          let found: boolean = false;
          const itemsCopy: FilterItemInterface[] = filter.items.map((item: FilterItemInterface) => {
            if(item.id === payloadData.filterItem.id) {
              found = true;
              return {
                ...item,
                name: payloadData.filterItem.name,
              };
            }
            return item;
          });
          if(!found) {
            itemsCopy.push(payloadData.filterItem);
          }
          return {
            ...filter,
            items: itemsCopy,
          };
        }
        return filter;
      });

      return {
        ...state,
        managementFilters: itemFiltersCopy,
      };

    case SiteFilterActionType.DeleteManagementSiteFilterItemCompleted:
      const deletePayloadData: { filterId: number, filterItem: FilterItemInterface } = action.payload;

      const deleteItemFiltersCopy: FilterInterface[] = state.managementFilters.map((filter: FilterInterface) => {
        if(filter.id === deletePayloadData.filterId) {
          const itemsCopy: FilterItemInterface[] = filter.items.filter((item: FilterItemInterface) => {
            if(item.id !== deletePayloadData.filterItem.id) { return item; }
          });
          return {
            ...filter,
            items: itemsCopy,
          };
        }
        return filter;
      });

      return {
        ...state,
        managementFilters: deleteItemFiltersCopy,
      };


    default:
      return state;
  }

}
